import React, { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, Palmtree } from 'lucide-react';

const UrlaubsrechnerResource = () => {
  const [searchParams] = useSearchParams();
  const q = searchParams.toString() ? `?${searchParams.toString()}` : '';
  const [jahresanspruch, setJahresanspruch] = useState('30');
  const [vorjahr, setVorjahr] = useState('5');
  const [genommen, setGenommen] = useState('12');

  const rest = useMemo(() => {
    const j = parseFloat(String(jahresanspruch).replace(',', '.')) || 0;
    const v = parseFloat(String(vorjahr).replace(',', '.')) || 0;
    const g = parseFloat(String(genommen).replace(',', '.')) || 0;
    return Math.max(0, Math.round((j + v - g) * 10) / 10);
  }, [jahresanspruch, vorjahr, genommen]);

  return (
    <div className="space-y-8">
      <div>
        <Link
          to={q ? `/${q}` : '/'}
          className="inline-flex items-center text-sm font-medium text-hrf-navy hover:text-hrf-navy-800 mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Zum Dashboard
        </Link>
        <div className="flex items-center gap-3">
          <div className="p-3 bg-emerald-500/10 rounded-lg">
            <Palmtree className="h-8 w-8 text-emerald-600" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-hrf-navy">Urlaubsanspruch</h1>
            <p className="mt-1 text-gray-600 text-sm">Resturlaub aus Anspruch, Übertrag und Verbrauch</p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 max-w-xl space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Jahresurlaubsanspruch (Tage)</label>
          <input
            type="text"
            inputMode="decimal"
            value={jahresanspruch}
            onChange={(e) => setJahresanspruch(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:border-hrf-navy"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Übertrag aus Vorjahr (Tage)</label>
          <input
            type="text"
            inputMode="decimal"
            value={vorjahr}
            onChange={(e) => setVorjahr(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:border-hrf-navy"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Bereits genommene Urlaubstage (laufendes Jahr)</label>
          <input
            type="text"
            inputMode="decimal"
            value={genommen}
            onChange={(e) => setGenommen(e.target.value)}
            className="w-full border border-gray-300 rounded-lg px-3 py-2 text-gray-900 focus:outline-none focus:ring-2 focus:ring-hrf-navy focus:border-hrf-navy"
          />
        </div>

        <div className="mt-6 p-4 bg-emerald-50 rounded-lg border border-emerald-100">
          <p className="text-xs text-emerald-800 uppercase tracking-wide mb-1">Resturlaub (geschätzt)</p>
          <p className="text-2xl font-semibold text-hrf-navy">{rest} Tage</p>
        </div>

        <p className="text-xs text-gray-500 leading-relaxed">
          Formel: Jahresanspruch + Übertrag − genommene Tage. Sonderfälle (Teilzeit, Krankheit, Betriebsurlaub) sind hier
          nicht abgebildet.
        </p>
      </div>
    </div>
  );
};

export default UrlaubsrechnerResource;
